import { useDimensions } from '@/hooks/useDimensions';
import StyleFilterMarketDesktop from './desktop';
import StyleFilterMarketMobile from './mobile';
import { useModel } from '../Home/Generator/model';
import { FormProvider } from 'react-hook-form';

export default function StyleFilterMarketplace() {
  const { isMobileOrPad } = useDimensions();

  const { form } = useModel();

  if (isMobileOrPad) {
    return (
      <FormProvider {...form}>
        <StyleFilterMarketMobile />
      </FormProvider>
    );
  }

  return (
    <FormProvider {...form}>
      <StyleFilterMarketDesktop />
    </FormProvider>
  );
}
